import { Dispatch, SetStateAction, useCallback } from 'react'
import { StockUnionType } from 'types/stock'
import { FirebaseDocRefType } from 'firebase/index'
import { getInitialStoreDefaultSchedule } from 'reducks/storeDefault/operations'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useToggleDefaultTypeDaily = (
  storeDefaultBreadRef: FirebaseDocRefType,
  setIsTypeDaily: Dispatch<SetStateAction<boolean>>,
  openDeleteScheduleCautionModal: (type: StockUnionType) => void,
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setScheduledGeneration: Dispatch<SetStateAction<boolean>>
) => {
  return useCallback(() => {
    setIsTypeDaily((prevState) => {
      if (prevState) {
        openDeleteScheduleCautionModal('daily')
        return true
      } else {
        const scheduleRef = storeDefaultBreadRef.parent.parent?.collection('store_default_schedules').doc()
        if (!scheduleRef) return prevState
        setDailySchedules([getInitialStoreDefaultSchedule(storeDefaultBreadRef, scheduleRef, 'daily')])
        setTimeout(() => setScheduledGeneration(true), 0)
        return !prevState
      }
    })
  }, [storeDefaultBreadRef, setIsTypeDaily, openDeleteScheduleCautionModal, setDailySchedules, setScheduledGeneration])
}

export default useToggleDefaultTypeDaily
